import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-table-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading font-semibold text-lg text-background-50">BasetaoSheet</span>
            </div>
            <p className="text-xs leading-relaxed mb-4 text-background-50/50">
              The most trusted independent resource for Basetao Spreadsheet guides, reviews, 
              and shopping strategies. Helping shoppers discover better products since 2026.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xs text-background-50/70"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-reddit-line text-xs text-background-50/70"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-pinterest-line text-xs text-background-50/70"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">Complete Guide</Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">
                  Main Website <i className="ri-external-link-line text-[10px]"></i>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 text-sm mb-4">Popular Topics</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">Basetao Spreadsheet Guide</Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">Shipping Cost Guide</Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">Product Research Tips</Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">Safety & Security</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 text-sm mb-4">Shop Categories</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">Shoes</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">T-Shirts</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">Jackets</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50 transition-colors">Bags</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} BasetaoSheet.club. All rights reserved. An independent resource — not affiliated with Basetao.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors">Privacy Policy</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}